import React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const UserCircle02Icon = (props: IconPropsType) => {
   const {
      width = 20,
      height = 20,
      fill = colors['gray-500'],
      secondFill = colors['white'],
      ...rest
   } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 20 20'
         fill='none'
         {...rest}
      >
         <g clip-path='url(#clip0_25286_35942)'>
            <path
               fill-rule='evenodd'
               clip-rule='evenodd'
               d='M9.99992 2.50065C5.85778 2.50065 2.49992 5.85851 2.49992 10.0007C2.49992 11.8516 3.17043 13.5459 4.28181 14.854C5.0455 13.9264 6.20298 13.334 7.49992 13.334H12.4999C13.7969 13.334 14.9543 13.9264 15.718 14.8541C16.8294 13.546 17.4999 11.8516 17.4999 10.0007C17.4999 5.85851 14.1421 2.50065 9.99992 2.50065ZM16.1418 16.8056C17.9993 15.128 19.1666 12.7007 19.1666 10.0007C19.1666 4.93804 15.0625 0.833984 9.99992 0.833984C4.93731 0.833984 0.833252 4.93804 0.833252 10.0007C0.833252 12.7007 2.00058 15.128 3.85808 16.8056C3.86774 16.8147 3.87765 16.8236 3.88779 16.8323C5.50967 18.2843 7.65168 19.1673 9.99992 19.1673C12.3482 19.1673 14.4902 18.2843 16.112 16.8323C16.1222 16.8236 16.1321 16.8147 16.1418 16.8056ZM14.5004 16.0008C14.0438 15.3928 13.3171 15.0006 12.4999 15.0006H7.49992C6.68278 15.0006 5.95603 15.3928 5.4994 16.0008C6.75298 16.9426 8.31128 17.5006 9.99992 17.5006C11.6886 17.5006 13.2469 16.9426 14.5004 16.0008ZM9.99992 5.41732C8.61921 5.41732 7.49992 6.53661 7.49992 7.91732C7.49992 9.29803 8.61921 10.4173 9.99992 10.4173C11.3806 10.4173 12.4999 9.29803 12.4999 7.91732C12.4999 6.53661 11.3806 5.41732 9.99992 5.41732ZM5.83325 7.91732C5.83325 5.61613 7.69873 3.75065 9.99992 3.75065C12.3011 3.75065 14.1666 5.61613 14.1666 7.91732C14.1666 10.2185 12.3011 12.084 9.99992 12.084C7.69873 12.084 5.83325 10.2185 5.83325 7.91732Z'
               fill={fill}
            />
         </g>
         <defs>
            <clipPath id='clip0_25286_35942'>
               <rect width='20' height='20' fill={secondFill} />
            </clipPath>
         </defs>
      </svg>
   )
}

export { UserCircle02Icon }
